export default __webpack_public_path__ + "static/media/CapaWelcome.4987ae92.png";